/**
 * @author Vladislav Urbánek <urbanek.vlada@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Továrna na konečný stavový automat.
 */
class StateMachineFactory {
  /**
   * Vytvoří instanci
   * @param {Class.<JavascriptStateMachine>} JavascriptStateMachine
   * @param {Class.<StateMachine>} StateMachine
   * @returns {StateMachineFactory} Nová instance
   */
  constructor(JavascriptStateMachine, StateMachine) {
    this.JavascriptStateMachine = JavascriptStateMachine;
    this.StateMachine = StateMachine;
  }

  /**
   * Vytvoří nový konečný stavový automat.
   * @param {Object} options
   * @returns {StateMachine} Vytvořený konečný stavový automat.
   */
  create(options) {
    return new this.StateMachine(this.JavascriptStateMachine, options);
  }
}

export default StateMachineFactory;
